import { Component, inject, signal } from '@angular/core';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';
import { ThirdPartyTracking } from './atoms/third-party-tracking/third-party-tracking';

@Component({
  selector: 'cad-ad-tracking',
  imports: [ThirdPartyTracking],
  templateUrl: './ad-tracking.html',
  styleUrl: './ad-tracking.css',
})
export class AdTracking {

  expanded = signal<boolean>(true);

  private createSparkCampaignService = inject(CreateSparkCampaign); 
}
